module.exports = __webpack_public_path__ + "static/img/fyCertificate2.a43c922.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/fyImg/fyCertificate2.jpg
// module id = U33q
// module chunks = 3